export default "__VITE_ASSET__D9k7raRG__"